import React from 'react'
import { Box, Grid, Typography, Chip } from '@material-ui/core'
import {
    WarningRounded as WarningRoundedIcon,
    CheckCircleRounded as CheckCircleRoundedIcon,
    InfoOutlined as InfoOutlinedIcon
} from '@material-ui/icons'
import Chart from 'react-apexcharts'
import strings from 'strings'
import { donutOptions } from './udHelpers'

const UDDecisionedRow = ({ decisioned, bigNumber, goal, goalPct, remaining, allClear, slaHours, streak, range, classes }) => {
    const slaSeverity = allClear ? 'neutral' : remaining > 0 ? 'warning' : 'success'
    const slaPalette = {
        warning: { bg: '#FEE2E2', fg: '#991B1B' },
        success: { bg: '#D1FAE5', fg: '#065F46' },
        neutral: { bg: '#f0f2f5', fg: '#6b7280' }
    }[slaSeverity]
    const slaLabel = allClear
        ? strings.UD.SLA_NO_DECISIONS_YET
        : remaining > 0
            ? strings.UD.SLA_MISSED.replace('{missed}', remaining).replace('{slaHours}', slaHours)
            : strings.UD.SLA_ALL_WITHIN.replace('{slaHours}', slaHours)
    const slaIcon = allClear
        ? <InfoOutlinedIcon style={{ fontSize: 16, color: slaPalette.fg }} />
        : remaining > 0
            ? <WarningRoundedIcon style={{ fontSize: 16, color: slaPalette.fg }} />
            : <CheckCircleRoundedIcon style={{ fontSize: 16, color: slaPalette.fg }} />

    return (
        <Grid container spacing={2} style={{ marginBottom: 16 }}>
            <Grid item xs={12} md={7}>
                <Box className={classes.card}>
                    <Typography className={classes.sectionLabel}>{range === 'today' ? strings.UD.APPLICATIONS_DECISIONED_TODAY : range === 'week' ? strings.UD.APPLICATIONS_DECISIONED_WEEK : strings.UD.APPLICATIONS_DECISIONED_MONTH}</Typography>
                    <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                        <Box>
                            <Box display="flex" alignItems="baseline" mb={0.5}>
                                <Typography className={classes.bigNumber}>{bigNumber}</Typography>
                                <Typography className={classes.bigNumberLight}>
                                    {goal > 0
                                        ? strings.UD.GOAL_LABEL.replace('{goal}', goal)
                                        : strings.UD.NO_GOAL_SET}
                                </Typography>
                            </Box>
                            <Typography className={classes.descText}>
                                {strings.UD.APPROVED_DECLINED.replace('{approved}', decisioned.approved).replace('{declined}', decisioned.declined)}
                                {decisioned.cancelled ? ` ${strings.UD.CANCELLED.replace('{cancelled}', decisioned.cancelled)}` : ''}
                            </Typography>
                            <Box style={{ marginTop: 10 }}>
                                <Chip
                                    icon={slaIcon}
                                    label={slaLabel}
                                    size="small"
                                    style={{
                                        fontSize: 12,
                                        fontWeight: 700,
                                        height: 28,
                                        borderRadius: 8,
                                        paddingLeft: 4,
                                        paddingRight: 8,
                                        backgroundColor: slaPalette.bg,
                                        color: slaPalette.fg
                                    }}
                                />
                            </Box>
                            <Box style={{ display: 'flex', gap: 8, marginTop: 12 }}>
                                <Chip
                                    label={strings.UD.VS_LAST.replace('{sign}', decisioned.delta >= 0 ? '+' : '').replace('{delta}', decisioned.delta)}
                                    className={decisioned.delta === 0 ? classes.grayChip : decisioned.delta > 0 ? classes.greenChip : classes.redChip}
                                    size="small"
                                />
                                <Chip
                                    label={allClear
                                        ? strings.UD.NO_DECISIONS_YET
                                        : remaining === 0
                                            ? strings.UD.TARGET_MET
                                            : strings.UD.ON_PACE}
                                    className={classes.grayChip}
                                    size="small"
                                />
                            </Box>
                        </Box>
                        <Box style={{ width: 160 }}>
                            <Chart type="radialBar" series={[goalPct]} options={donutOptions} height={160} />
                        </Box>
                    </Box>
                </Box>
            </Grid>
            <Grid item xs={12} md={5}>
                <Box className={classes.darkCard}>
                    <Typography className={classes.sectionLabel} style={{ color: '#5a6480' }}>{strings.UD.DECISION_STREAK}</Typography>
                    <Box display="flex" alignItems="baseline" mb={1}>
                        <Typography className={classes.bigNumberDark}>{streak.days}</Typography>
                        <Typography className={classes.bigNumberDarkUnit}>{streak.days === 1 ? strings.UD.DAY : strings.UD.DAYS}</Typography>
                    </Box>
                    <Typography className={classes.descTextDark}>
                        {streak.days > 0
                            ? strings.UD.STREAK_ACTIVE.replace('{days}', streak.days).replace('{dayLabel}', streak.days === 1 ? strings.UD.DAY : strings.UD.DAYS)
                            : strings.UD.NO_ACTIVE_STREAK}
                    </Typography>
                    <Box className={classes.streakDots}>
                        {Array.from({ length: Math.max(streak.days, 0) }).map((_, i) => (
                            <span key={i} className={classes.streakDot} />
                        ))}
                        {Array.from({ length: Math.max(0, 18 - streak.days) }).map((_, i) => (
                            <span key={`f-${i}`} className={classes.streakDotFaded} />
                        ))}
                    </Box>
                </Box>
            </Grid>
        </Grid>
    )
}

export default UDDecisionedRow
